export const profileConstants = {
  GET_ALL_EDUCATION: 'GET_ALL_EDUCATION',
  GET_ALL_MEMBERSHIP: 'GET_ALL_MEMBERSHIP',
  GET_ALL_ACHIEVEMENT: 'GET_ALL_ACHIEVEMENT',
  GET_ALL_REGISTRATION: 'GET_ALL_REGISTRATION'
};
